import * as API from "middleware/api";

export const loadListByIdForm = (idForm) => API.executeWithAccessToken("/core.listTransactionTemplates", { idForm });
export const loadListByIdActivity = (idActivityTemplate) =>
    API.executeWithAccessToken("/core.listTransactionTemplates", { idActivityTemplate });

export const deleteItem = ({ idTransactionTemplate }) =>
    API.executeWithAccessToken("/core.deleteTransactionTemplate", { idTransactionTemplate });
